import { Forbidden, Success, Unauthorized } from "../Utils/Responses";
import { api } from "./api";

type TagListCategoryResponse = Success | Unauthorized | Forbidden;

export interface ITargetAudience {
  identifier: string;
  name: string;
}

class TargetAudienceService {
  static async listTargets(): Promise<ITargetAudience[]> {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      const response = await api.get(`/admin/target-audiences`, config);
      if (response.status === 200) {
        return response.data.data;
      }

      throw new Error("Can not list Categories.");
    } catch (error: any) {
      throw new Error("Can not list Categories.");
    }
  }
}

export default TargetAudienceService;
